import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { format, subDays } from "date-fns";
import * as React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { EditIcon } from "../../../../assets/CommonAssets";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import IVFluidEditModal from "../IVFluidEditModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  backgroundColor: theme.palette.primary.main,
  whiteSpace: "nowrap",
  color: theme.palette.primary.contrastText,
  letterSpacing: 0,
}));

const IVFlowTable = (props) => {
  const defaultValues = {
    hold: false,
    stop: false,
    cancel: false,
    start: false,
    end: false,
  };

  const { register, setValue, control } = useForm({
    mode: "onChange",
    defaultValues,
  });

  let localStorageValue = JSON.parse(localStorage.getItem("userInfo"));
  const [openIVFluidEditModal, setOpenIvFluidEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleCheckboxChange = (row, event, fieldName) => {
    props.setIvId(row?.ivID);
    props.setSelectedFieldName(fieldName);
    if (event.target.value === false && fieldName === "hold") {
      props.setOpenConfirmationModal(true);
    } else if (event.target.value === true) {
      props.setOpenConfirmationModal(true);
    }
    props.setStatus(event.target.value);
  };

  useEffect(() => {
    if (!props.openConfirmationModal || props.data) {
      for (let i = 0; i < props.data.length; i++) {
        setValue(`hold${i}`, props.data[i]?.hold);
        setValue(`stop${i}`, props.data[i]?.stop);
        setValue(`cancel${i}`, props.data[i]?.cancel);
        setValue(`start${i}`, props.data[i]?.start);
        setValue(`end${i}`, props.data[i]?.end);
      }
    }
  }, [props.openConfirmationModal, props.data]);

  let ivHoldDisabledValue = props.userActions.some(
    (action) => action?.action === "Iv Hold" && action.isAction
  );
  let ivStopDisabledValue = props.userActions.some(
    (action) => action?.action === "Iv Stop" && action.isAction
  );
  let ivCancelDisabledValue = props.userActions.some(
    (action) => action?.action === "Iv Cancel" && action.isAction
  );
  let ivStartDisabledValue = props.userActions.some(
    (action) => action?.action === "Iv Start" && action.isAction
  );
  let ivEndDisabledValue = props.userActions.some(
    (action) => action?.action === "Iv End" && action.isAction
  );

  return (
    <div className="grid w-auto">
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        <Paper sx={{ width: "100%", my: 1 }}>
          <TableContainer
            sx={{
              "&::-webkit-scrollbar": {
                width: 7,
                height: 10,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#7393B3",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "lightBlue",
              },
            }}
            className="rounded h-[450px] 2xl:h-[450px] border"
          >
            <Table size="small" stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow className="tracking-normal">
                  <StyledTableCell>Actions</StyledTableCell>
                  <StyledTableCell>Date</StyledTableCell>
                  <StyledTableCell>IV Fluid</StyledTableCell>
                  <StyledTableCell>
                    Intravenous Infusion Details
                  </StyledTableCell>
                  <StyledTableCell>Dose</StyledTableCell>
                  <StyledTableCell>Volume</StyledTableCell>
                  <StyledTableCell>Rate of Infusion</StyledTableCell>
                  <StyledTableCell>Doctor</StyledTableCell>
                  <StyledTableCell>Hold</StyledTableCell>
                  <StyledTableCell>Stop</StyledTableCell>
                  <StyledTableCell>Cancel</StyledTableCell>
                  <StyledTableCell>Start</StyledTableCell>
                  <StyledTableCell>Start By</StyledTableCell>
                  <StyledTableCell>End</StyledTableCell>
                  <StyledTableCell>Stopped By</StyledTableCell>
                  <StyledTableCell>Hold By</StyledTableCell>
                  <StyledTableCell>Start Time</StyledTableCell>
                  <StyledTableCell>End Time</StyledTableCell>
                  <StyledTableCell>Remark</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data?.map((row, index) => {
                  const currentDate = new Date(
                    localStorageValue.currentDateTime
                  );

                  const formattedNextDayDate = format(
                    currentDate,
                    "dd/MM/yyyy"
                  );
                  const prevDay = subDays(currentDate, 1);
                  const formattedPrevDayDate = format(prevDay, "dd/MM/yyyy");

                  // Determine if row.date is today or yesterday
                  const isCurrentDay = formattedNextDayDate === row.date;
                  const isPrevDay = formattedPrevDayDate === row.date;
                  const shouldDisableCheckbox = !(isCurrentDay || isPrevDay);

                  return (
                    <TableRow
                      key={row.ivId}
                      rowSpan={row.intravenousInfusionDetailsDtoList?.length}
                      className="tracking-normal"
                    >
                      <TableCell>
                        <button
                          type="button"
                          onClick={() => {
                            setOpenIvFluidEditModal(true);
                            setSelectedRow(row);
                          }}
                        >
                          <EditIcon />
                        </button>
                      </TableCell>

                      <TableCell className="whitespace-nowrap border-l-2 border-r-2 ">
                        {row.date}
                      </TableCell>
                      <TableCell>{row.ivFluid}</TableCell>
                      <TableCell className="border-l-2 ">
                        {row.intravenousInfusionDetailsDtoList?.map((item) => {
                          return (
                            <p className="whitespace-nowrap">
                              {item.drugAdded}
                            </p>
                          );
                        })}
                      </TableCell>
                      <TableCell className="border-l-2 ">
                        {row.intravenousInfusionDetailsDtoList?.map((item) => {
                          return (
                            <p className="whitespace-nowrap">
                              {item.doseOfAdded}
                            </p>
                          );
                        })}
                      </TableCell>
                      <TableCell className="border-l-2 ">{row.vol}</TableCell>
                      <TableCell className="border-l-2 ">
                        {row.rateOfInfusion}
                      </TableCell>
                      <TableCell className="whitespace-nowrap border-l-2">
                        {row.doctor}
                      </TableCell>
                      <TableCell className="border-l-2 " padding="checkbox">
                        <CheckBoxField
                          disabled={
                            row.stop === true || row.end
                              ? true
                              : shouldDisableCheckbox === true &&
                                ivHoldDisabledValue === true
                              ? true
                              : false
                          }
                          value={row.hold}
                          name={`hold${index}`}
                          control={control}
                          inputRef={{
                            ...register(`hold${index}`, {
                              onChange: (event) => {
                                handleCheckboxChange(row, event, "hold");
                                setValue(`hold${index}`, event.target.value);
                              },
                            }),
                          }}
                        />
                      </TableCell>
                      <TableCell className="border-l-2 " padding="checkbox">
                        <CheckBoxField
                          disabled={
                            row.hold || row.end
                              ? true
                              : false ||
                                (shouldDisableCheckbox && ivStopDisabledValue)
                          }
                          value={row.stop}
                          name={`stop${index}`}
                          control={control}
                          inputRef={{
                            ...register(`stop${index}`, {
                              onChange: (event) => {
                                handleCheckboxChange(row, event, "stop");
                                setValue(`stop${index}`, true);
                              },
                            }),
                          }}
                        />
                      </TableCell>
                      <TableCell className="border-l-2 " padding="checkbox">
                        <CheckBoxField
                          disabled={
                            row.stop === true || row.end
                              ? true
                              : false ||
                                (ivCancelDisabledValue &&
                                  row.hold === false &&
                                  shouldDisableCheckbox === false)
                              ? false
                              : true
                          }
                          value={row.cancel}
                          name={`cancel${index}`}
                          control={control}
                          inputRef={{
                            ...register(`cancel${index}`, {
                              onChange: (event) => {
                                handleCheckboxChange(row, event, "cancel");
                                setValue(`cancel${index}`, true);
                              },
                            }),
                          }}
                        />
                      </TableCell>
                      <TableCell className="border-l-2 " padding="checkbox">
                        <CheckBoxField
                          disabled={
                            row.stop || row.end
                              ? true
                              : false ||
                                (ivStartDisabledValue &&
                                  shouldDisableCheckbox === false)
                              ? false
                              : true
                          }
                          value={row.start}
                          name={`start${index}`}
                          control={control}
                          inputRef={{
                            ...register(`start${index}`, {
                              onChange: (event) => {
                                handleCheckboxChange(row, event, "start");
                                setValue(`start${index}`, true);
                              },
                            }),
                          }}
                        />
                      </TableCell>

                      <TableCell className="border-l-2 whitespace-nowrap">
                        {row.startBy}
                      </TableCell>
                      <TableCell className="border-l-2 " padding="checkbox">
                        <CheckBoxField
                          disabled={
                            row.hold || row.stop
                              ? true
                              : ivEndDisabledValue && shouldDisableCheckbox
                          }
                          value={row.end}
                          name={`end${index}`}
                          control={control}
                          inputRef={{
                            ...register(`end${index}`, {
                              onChange: (event) => {
                                handleCheckboxChange(row, event, "end");
                                setValue(`end${index}`, true);
                              },
                            }),
                          }}
                        />
                      </TableCell>
                      <TableCell className="border-l-2 whitespace-nowrap">
                        {row.stoppedBy}
                      </TableCell>
                      <TableCell className="border-l-2 whitespace-nowrap">
                        {row.holdBy}
                      </TableCell>
                      <TableCell className="whitespace-nowrap border-l-2">
                        {row.startTime}
                      </TableCell>
                      <TableCell className="whitespace-nowrap border-l-2">
                        {row.endTime}
                      </TableCell>
                      <TableCell className="border-l-2 ">
                        {row.remark}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      {openIVFluidEditModal && (
        <IVFluidEditModal
          open={openIVFluidEditModal}
          handleClose={() => setOpenIvFluidEditModal(false)}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          userActions={props.userActions}
          menuId={props.menuId}
          privilege={props.privilege}
          setOpenLoader={props.setOpenLoader}
          populateTable={props.populateTable}
        />
      )}
    </div>
  );
};

export default IVFlowTable;
